import { useCallback, useMemo } from "react";
import { useParams } from "react-router-dom";

import { Button, SheetBody, SheetFooter } from "twyne-new.ui"

import { useVersionStore } from "../store";

import Form from "./Form";
import Table from "./Table";
import { usePagination } from "./Table/Pagination";

export default function Content({ entityName, entityCollection, onClose, loading }) {
  const { id: entityId } = useParams()
  const { onNextPage, options } = usePagination()
  const { collections: { items: versions, useLoad: useLoadVersions }, collection: { save: createVersion } } = useVersionStore()
  const { item: data, deleteEntry, version: { item: version, setItem: setVersion, reset: resetVersion } } = entityCollection || {}

  const params = useMemo(() => ({
    entityId,
    entity: entityName,
    options,
    autoRefresh: false,
  }), [entityName, entityId, options])

  const loadVersions = useLoadVersions(params)

  const handleCreate = useCallback(async entry => {
    await createVersion({
      ...entry,
      id: null,
      entityId,
      entity: entityName,
    })
    await loadVersions()
  }, [createVersion, loadVersions, entityId, entityName])

  const handleEdit = useCallback(async entry => {
    onClose()
    setVersion(entry)
  }, [onClose, setVersion])

  const handleDelete = useCallback(async entry => {
    const { id, entityId } = entry
    const version = { id, entityId }
    await deleteEntry(entry, { version })
    await loadVersions()
  }, [deleteEntry, loadVersions])

  const handleDefault = useCallback(async () => {
    onClose()
    resetVersion()
  }, [onClose, resetVersion])

  return <>
    <Body loading={loading} version={version} versions={versions} onEdit={handleEdit}
      onDelete={handleDelete} onDefault={handleDefault} onNextPage={onNextPage} />
    <Footer data={data} version={version} onCreate={handleCreate} onCancel={onClose} />
  </>
}

function Body({ loading, versions, version, onEdit, onDelete, onDefault, onNextPage }) {
  return <SheetBody>
    <Table loading={loading} versions={versions} version={version} onEdit={onEdit}
      onDelete={onDelete} onDefault={onDefault} onNextPage={onNextPage} />
  </SheetBody>
}

function Footer({ data, version, onCreate, onCancel }) {
  return <SheetFooter>
    <Button color="neutral" variant="ghost" onClick={onCancel}>Cancel</Button>
    <Form data={data} version={version} onCreate={onCreate} />
  </SheetFooter>
}
